__webpack_require__.p = "https://pricing-preprod.mbopartners.com/";